<template>
  <div>
    <b-modal
      id="alias"
      ref="modal"
      :title="user && user.alias ? 'Change Alias' : 'Add Alias'"
      @ok="handleOk"
      :ok-title="loading ? '...Loading' : 'Save Alias'"
    >
      <p>
        Set an Alias for {{ convertFromMutez(aliaserCost) }}tez. Your alias will display instead of
        your wallet address in games, marketplaces, and leaderboards. <br /><br />
        1. Generate or enter your new alias below. <br />
        2. Click "save" alias <br />
        3. Approve the transaction in your wallet app (gas fees apply because this alias is saved to
        the Tezos blockchain). <br />
      </p>
      <p>An alias can be up to 15 chars long. Pls keep it PG :)</p>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Alias"
          label-for="alias-input"
          invalid-feedback="Alias is required"
          :state="aliasState"
        >
          <b-form-input
            id="alias-input"
            v-model="aliasInput"
            :state="aliasState"
            required
          ></b-form-input>
          <b-button @click="generateAlias" class="mt-3">Generate Alias</b-button>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

import { convertFromMutez } from '../../util'
import { handleGlobalError } from '../../util'

export default {
  data() {
    return {
      aliasInput: '',
      aliasState: null,
      aliaserCost: 250000,
      loading: false,
      originalAlias: this.$store.getters.user ? this.$store.getters.user.alias : null,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    walletAddress() {
      return this.user ? this.user.walletAddress : null
    },
    tezos() {
      return this.$store.getters.tezos
    },
  },
  mounted() {
    if (this.user && this.user.alias) {
      this.aliasInput = this.user.alias
    }
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.aliasState = valid
      return valid
    },
    convertFromMutez,
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      try {
        if (this.walletAddress === null) {
          return
        }
        this.aliasInput = this.aliasInput.trim()
        if (this.aliasInput.length > 15) {
          alert(
            `Max alias length is 15 chars. If you feel this is too restrictive, please reach out to an admin on discord.`
          )
          return
        }
        if (this.aliasInput.length < 3) {
          alert(
            'Min alias length is 3 chars. If you feel this is too restrictive, please reach out to an admin on discord.'
          )
          return
        }
        this.loading = true

        const aliaser = await this.tezos.wallet.at(process.env.VUE_APP_PP_ALIASER)

        const opts = {}
        opts.amount = this.aliaserCost
        opts.mutez = true
        let op = await aliaser.methods.set_alias(this.aliasInput).send(opts)
        this.$store.commit('updateUser', { alias: this.aliasInput })
        this.$bvModal.hide('alias')

        await op.confirmation(1)
        this.loading = false
      } catch (e) {
        this.loading = false
        console.error('Unable to connect wallet', e)
        this.$store.commit('updateUser', { alias: this.originalAlias })
      }
    },
    async generateAlias() {
      try {
        const resp = await axios.get(`${process.env.VUE_APP_PXL_API}/user-alias`, {
          wallet_alias_mapping: {
            walletAddress: this.$store.getters.wallet,
            alias: 'Iamalias',
          },
        })
        console.log(resp)
        this.$nextTick(() => {
          this.aliasInput = resp.data
        })
      } catch (error) {
        console.error('error trying to generate alias', error)
        handleGlobalError(this, error, 'generate alias')
      }
    },
  },
}
</script>
